import React, { Fragment, useEffect, useState, } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  FormFeedback
} from "reactstrap";
import { connect } from "react-redux";
import {
  addProduct,
  clearCreateProductError,
  createProduct
} from "../../store/products/actions.js";
import Message from "../../CommonData/Data/Message.js";
import { updateForm } from "../../store/form/actions.js";
import VWLoading from "../../components/vwLoading/vwLoading.js";

const AddProduct = (props) => {

  const { handleClose, errorMessage, form, isCreatePending } = props;
  const { formAddProduct } = form || {};
  const { productName } = formAddProduct || {};

  useEffect(() => {
    props.updateForm({
      formAddProduct: {},
      errors: {}
    })

    props.clearCreateProductError();
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [])

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    event.preventDefault();
    props.updateForm({
      formAddProduct: {
        ...form.formAddProduct,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });
  }

  const handleCreateProduct = (e) => {
    e.preventDefault();
    const { formAddProduct } = form || {};
    const { productName } = formAddProduct || {};
    const currentErrors = {};

    if (!productName) {
      currentErrors.productName = "Product name is required"
    }

    props.updateForm({
      formAddProduct: {
        ...form.formAddProduct,
      },
      errors: currentErrors,
    })

    if (Object.keys(currentErrors).length === 0) {
      props.createProduct(form.formAddProduct);
    }
  };

  return isCreatePending ? (<VWLoading />) : (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <Form onSubmit={handleCreateProduct}>
        <FormGroup>
          <Label>Product Name</Label><span className="text-danger">*</span>
          <Input
            autoFocus={true}
            type="text"
            name="productName"
            placeholder="Enter product name"
            onChange={handleInputChange}
            value={productName || ""}
            invalid={form && form.errors && form.errors.productName}
          />
          <FormFeedback>{form && form.errors && form.errors.productName}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Button
            type="submit"
            className='me-4'
            color="success"
            onClick={handleCreateProduct}
          >
            Create
          </Button>
          <Button
            color="danger"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>

    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  form: state.form.form,
  AddProductForm: state.products.AddProductForm,
  isCreatePending: state.products.isCreatePending,
  errorMessage: state.products.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (AddProductForm) => dispatch(updateForm(AddProductForm)),
  addProduct: (AddProductForm) => dispatch(addProduct(AddProductForm)),
  clearCreateProductError: () => dispatch(clearCreateProductError()),
  createProduct: (AddProduct) => dispatch(createProduct(AddProduct)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddProduct);